import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class TabsService {

  public adminTabsVisited: boolean;

  hideTabBarPages = [
    "nutrition-tracking",
    "cardio-tracking",
    "workout-tracking",
    "/meal-plan/",
    "meal-plan-builder",
    //"/workout-program/",
    "workout-program-builder",
    "/edit",
    "/my-profile/menu",
  ];

  constructor(private router: Router, private platform: Platform) {
    console.log("TabsService constructor");
    this.platform.ready().then(() => {
      this.navEvents();
    });
  }

  public hideTabs() {
    const tabBar = document.getElementById('tabs-footer');
    if (tabBar && tabBar.style.display !== 'none') tabBar.style.display = 'none';
  }

  public showTabs() {
    const tabBar = document.getElementById('tabs-footer');
    if (tabBar && tabBar.style.display !== 'flex') tabBar.style.display = 'flex';
  }

  // A simple subscription that tells us what page we're currently navigating to.
  private navEvents() {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => { 
      console.log("NavigationEnd", e.url);
      this.showHideTabs(e);
    });
  }

  private showHideTabs(e: NavigationEnd) {
    if(!this.platform.is("mobile")) {
      this.hideTabs();
      return
    }

    let shouldHide = false;
    for (const page of this.hideTabBarPages) {
      if(e.url.indexOf(page) > -1) {
        shouldHide = true;
        break;
      }
    }

    // Not ideal to set the timeout, but I haven't figured out a better method to wait until the page is in transition...
    try {
      setTimeout(() => shouldHide ? this.hideTabs() : this.showTabs(), 300);
    } catch (err) {
    }
  }
}